// extracted by mini-css-extract-plugin
module.exports = {"sdlzxfw":"sdlzxfw","s3j7bhc":"s3j7bhc"};